var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.starts-with.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.error.cause.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var isPlainObject = require('lodash.isplainobject');
var parser = require('postcss-selector-parser');
var parseSelector = parser();
module.exports = {
  isUsableColor: function isUsableColor(color, values) {
    return isPlainObject(values) && color !== 'gray' && values[600];
  },
  /**
   * @param {string} selector
   */
  commonTrailingPseudos: function commonTrailingPseudos(selector) {
    var ast = parseSelector.astSync(selector);

    /** @type {import('postcss-selector-parser').Pseudo[][]} */
    var matrix = [];

    // Put the pseudo elements in reverse order in a sparse, column-major 2D array
    var _iterator = _createForOfIteratorHelper(ast.nodes.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          i = _step$value[0],
          sel = _step$value[1];
        var _iterator2 = _createForOfIteratorHelper(_toConsumableArray(sel.nodes).reverse().entries()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
              j = _step2$value[0],
              child = _step2$value[1];
            // We only care about pseudo elements
            if (child.type !== 'pseudo' || !child.value.startsWith('::')) {
              break;
            }
            matrix[j] = matrix[j] || [];
            matrix[j][i] = child;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var trailingPseudos = parser.selector();

    // At this point the pseudo elements are in a column-major 2D array
    // This means each row contains one "column" of pseudo elements from each selector
    // We can compare all the pseudo elements in a row to see if they are the same
    for (var _i = 0, _matrix = matrix; _i < _matrix.length; _i++) {
      var pseudos = _matrix[_i];
      // It's a sparse 2D array so there are going to be holes in the rows
      // We skip those
      if (!pseudos) {
        continue;
      }
      var values = new Set(_toConsumableArray(pseudos.map(function (p) {
        return p.value;
      })));

      // The pseudo elements are not the same
      if (values.size > 1) {
        break;
      }
      pseudos.forEach(function (pseudo) {
        return pseudo.remove();
      });
      trailingPseudos.prepend(pseudos[0]);
    }
    if (trailingPseudos.nodes.length) {
      return [trailingPseudos.toString(), ast.toString()];
    }
    return [null, selector];
  }
};